import type { Presence } from "../../state/stores";

/** The button beside jump: what the crosshair offers, or nothing (spec 2p §2.2, §2.4). A pin wins over removing. */
export function contextAction(s: { inRoom: boolean; roomAction: string | null; lookMarker: boolean; removable: boolean; building: boolean }):
  { label: string; danger: boolean } | null {
  if (s.building) return null;
  if (s.inRoom) return s.roomAction ? { label: s.roomAction, danger: false } : null;
  if (s.lookMarker) return { label: "標記", danger: false };
  if (s.removable) return { label: "移除", danger: true };
  return null;
}

export type IconId = "chat" | "mail" | "inventory" | "plot" | "room";

/** The icons along the top: the room has no plot panel (spec 2o §2.1). */
export function topIcons(inRoom: boolean): { id: IconId; glyph: string; label: string }[] {
  const icons: { id: IconId; glyph: string; label: string }[] = [
    { id: "chat", glyph: "💬", label: "聊天" },
    { id: "mail", glyph: "✉", label: "信箱" },
    { id: "inventory", glyph: "🎒", label: "物品欄" },
  ];
  if (!inRoom) icons.push({ id: "plot", glyph: "🗺", label: "領地" });
  icons.push({ id: "room", glyph: "🏠", label: inRoom ? "回大廳" : "回房間" });
  return icons;
}

export function joinLabel(p: Presence | null): string | null {
  if (!p || p.consentMode !== "join") return null;
  return p.state === "joined" ? "退出領地" : "加入領地";
}

export type BuildMode = "place" | "marker" | null;
export const buildMode = (placing: boolean, tool: string | null): BuildMode => (placing ? "place" : tool === "marker" ? "marker" : null);
